<template>
    <v-dialog v-model="dialog" max-width="500">
        <template #activator="{on}">
            <v-btn v-on="on">Add field</v-btn>        
        </template>
        <v-card>
            <v-card-title>Add Field</v-card-title>
            <v-card-text>
                <v-form v-model="form">
                    <v-row>
                        <v-select
                        :items="fieldHandles"
                        v-model="model.handle"
                        label="Field"
                        />
                    </v-row>
                    <v-row>
                        <v-select
                        :items="fieldValues"
                        v-model="model.value"
                        label="Value"
                        />
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="add()">Add</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    props: {
        set: {
            type:Object,
            required:true
        }
    },
    data: () => ({
        dialog: false,
        form: false,
        model: {
            value: null,
            handle: null,
        },
    }),    
    computed: {
        ...mapGetters("productSets", ["fieldHandles"]),
        fieldValues(){
            if(this.model.handle == "tip"){
                return [
                { text: "PARALLEL", value: "PARALLEL" },
                { text: "TAPER", value: "TAPER" },
                { text: "FLEXIBLE", value: "FLEXIBLE" },
                ];
            }
            return []
        },
    },
    mounted() {
      this.getFieldHandles();
    },
    methods: {
        ...mapActions("productSets", ["getFieldHandles", "addField"]),
        add() {
            this.addField({ setId: this.set.id, model: this.model }).then(
                () => {
                    this.dialog = false;
                    this.$emit('update')
                }
            );
        },
    }
}
</script>